import type { U3129TaskItem } from "../U3129Service";

/** Libellé affiché pour une tâche (initLU) : description selon la langue UI, sinon l’autre langue, puis code, puis id. */
export function formatU3129TaskLabel(task: U3129TaskItem | undefined, locale: string): string {
  if (!task) return "";
  const isFr = (locale || "en").toLowerCase().startsWith("fr");
  const primary = isFr ? task.taskDescriptionFr?.trim() : task.taskDescriptionEn?.trim();
  if (primary) return primary;
  const fallback = isFr ? task.taskDescriptionEn?.trim() : task.taskDescriptionFr?.trim();
  if (fallback) return fallback;
  return task.taskCode?.trim() || task.id;
}

const COMPARE_OPTS: Intl.CollatorOptions = { numeric: true, sensitivity: "base" };

/**
 * Copie triée alpha-numériquement sur le libellé affiché (`formatU3129TaskLabel`).
 * Tie-break : taskCode puis id. BL-0522.
 */
export function u3129SortTasksByDisplayLabel(tasks: U3129TaskItem[], locale: string): U3129TaskItem[] {
  const isFr = (locale || "en").toLowerCase().startsWith("fr");
  const collatorLocale = isFr ? "fr" : "en";
  return [...tasks].sort((a, b) => {
    const labelCmp = formatU3129TaskLabel(a, locale).localeCompare(
      formatU3129TaskLabel(b, locale),
      collatorLocale,
      COMPARE_OPTS,
    );
    if (labelCmp !== 0) return labelCmp;
    const codeA = a.taskCode?.trim() ?? "";
    const codeB = b.taskCode?.trim() ?? "";
    const codeCmp = codeA.localeCompare(codeB, collatorLocale, COMPARE_OPTS);
    if (codeCmp !== 0) return codeCmp;
    return (a.id ?? "").localeCompare(b.id ?? "");
  });
}
